import React, { createContext, useContext, useEffect } from "react";

// MENU-ENFOQUE (ajuste fino, docs/plan-corto-menu-enfoque.md): cualquier
// pantalla puede desactivar la franja de 12px que abre el menu por el
// borde ("Asomar") mientras cierto estado propio este activo -- pensado
// para pantallas que YA usan esa misma franja de borde para algo suyo
// (hoy: Tickets, cuando la lista esta colapsada). Reutilizable a
// proposito: otra pantalla futura con el mismo conflicto solo necesita
// llamar useDisableEdgeAsomar(suPropiaCondicion), nada mas.
//
// Pensado para UN solo llamador activo a la vez (una pantalla montada
// por ruta) -- si en el futuro dos llamaran a la vez, "gana" el ultimo
// efecto en correr; no hay caso real hoy que lo necesite (ver nota en el
// plan sobre el editor de flujos).
const NavFocusEdgeContext = createContext({ setEdgeAsomarDisabled: () => {} });

export const NavFocusEdgeProvider = NavFocusEdgeContext.Provider;

export const useDisableEdgeAsomar = (disabled) => {
  const { setEdgeAsomarDisabled } = useContext(NavFocusEdgeContext);
  useEffect(() => {
    setEdgeAsomarDisabled(Boolean(disabled));
    return () => setEdgeAsomarDisabled(false);
  }, [disabled, setEdgeAsomarDisabled]);
};

export default NavFocusEdgeContext;
